import React, { useState } from 'react';
import { StyleSheet, Text, View } from 'react-native';
import type { ColorPalette } from '../constants/colors';
import { spacing } from '../constants/spacing';
import { typography } from '../constants/typography';
import { AppButton } from './AppButton';
import { AppInput } from './AppInput';

export function RequestCancelActions({
  visible,
  palette,
  startTitle,
  confirmTitle,
  keepTitle,
  placeholder = 'Enter reason for cancellation',
  busy = false,
  error,
  onConfirm,
}: {
  visible: boolean;
  palette: ColorPalette;
  startTitle: string;
  confirmTitle: string;
  keepTitle: string;
  placeholder?: string;
  busy?: boolean;
  error?: string | null;
  onConfirm: (reason: string) => void | Promise<void>;
}) {
  const [showReason, setShowReason] = useState(false);
  const [reason, setReason] = useState('');
  const [localError, setLocalError] = useState<string | null>(null);

  if (!visible) return null;

  const message = localError || error;

  if (!showReason) {
    return (
      <AppButton
        title={startTitle}
        variant="danger"
        onPress={() => {
          setShowReason(true);
          setLocalError(null);
        }}
      />
    );
  }

  return (
    <View style={styles.cancelBlock}>
      <AppInput
        label="Cancellation reason"
        value={reason}
        onChangeText={value => {
          setReason(value);
          setLocalError(null);
        }}
        placeholder={placeholder}
      />
      {message ? (
        <Text accessibilityRole="alert" style={[styles.error, { color: palette.error }]}>
          {message}
        </Text>
      ) : null}
      <AppButton
        title={confirmTitle}
        variant="danger"
        onPress={() => {
          const trimmed = reason.trim();
          if (!trimmed) {
            setLocalError('Cancellation reason is required.');
            return;
          }
          return onConfirm(trimmed);
        }}
        loading={busy}
        disabled={busy}
      />
      <AppButton
        title={keepTitle}
        variant="text"
        onPress={() => {
          setShowReason(false);
          setReason('');
          setLocalError(null);
        }}
        disabled={busy}
      />
    </View>
  );
}

const styles = StyleSheet.create({
  cancelBlock: { gap: spacing.md, marginBottom: spacing.xl },
  error: { ...typography.caption },
});
